import { Typography } from '@mui/material';
import axios from 'axios'
import React, { useEffect, useState } from 'react';
import Card from "../components/Card";
import Genres from '../components/Genres';
import Paging from "../components/Paging";
import useGenre from "../hooks/useGenre";
import { model, fblink } from '../config/config';

function Movies() {
  const [page, setPage] = useState(1);
  const [content, setContent] = useState([]);
  const [genres, setGenres] = useState([]);
  const [selectedGenres, setSelectedGenres] = useState([]);
  const genreforURL = useGenre(selectedGenres);

  const fetchMovies = async () => {
    const { data } = await axios.get(
      `${fblink}/watchface/${model}.json?orderBy="binfile"&startAt="${genreforURL}"&endAt="${genreforURL}"&limitToFirst=100`
    );
    let arrayOfObjects = Object.keys(data).map(key => {
		let ar = data[key]
		ar.key = key
		return ar})
    setContent(arrayOfObjects);
	localStorage.setItem("attempts", "0")
  }
  useEffect(() => {
    fetchMovies();
    
  }, [page, genreforURL])
  return (
    <div className='container' style={{ padding: "64px 1vw 64px 1vw" }}>
      <Typography variant="h4" component="h4" mb={4}>
       Amazfit {model.toUpperCase()} watch face categories
      </Typography>
      <Genres
        type="name"
        selectedGenres={selectedGenres}
        setSelectedGenres={setSelectedGenres}
        genres={genres}
        setGenres={setGenres}
        setPage={setPage}
      />
      <div className="card-grid">
        {
          content && content.map(item => {
            return <Card key={item.fileid} {...item} binfile="name" />
          })

        }
      </div>
      
    </div>
  )
}

export default Movies